function sanitizeBranchName(branch: string) {
  return (
    branch
      // Regex treats '_' as a word character, so we convert it to
      // hyphens first to get nicer sanitized names.
      .replace(/_/g, "-")
      // Convert to pascal case
      .toLowerCase()
      .replace(/\b(\w)/g, s => s.toUpperCase())
      // Remove non-alpha characters
      .replace(/\W/g, "")
      // Prevent the stack prefix from being too long
      .slice(0, 30)
  );
}

// keep in sync with ci/cdk-ts/src/types/ApplicationNames.ts
// Replace all consecutive non-domain name safe characters with '-'
//
// Note that here in the CI environment you can use CI_COMMIT_REF_SLUG, but that
// doesn't exist locally and so, we've mostly replicated it here with this
// function that we can replicate / run in multiple places.
// keep in sync with lang-js/build-scripts/util/deploys.js
// Replace all consecutive non-domain name safe characters with '-'
// and remove leading/trailing '-'.
export function getEnvironmentSlug(environment: string, branch: string) {
  return environment === "Prod"
    ? "production"
    : branch.replace(/[^A-Za-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function getEnvName(isProduction: boolean, gitBranch: string) {
  return isProduction
    ? "Prod"
    : gitBranch === "master"
    ? "Stage"
    : "Br" + sanitizeBranchName(gitBranch);
}

export function readNonZeroNaturalNumber(
  envVar: string | undefined,
  defaultValue: number | undefined = undefined
) {
  if (!envVar) {
    return undefined;
  }
  const n = Number.parseInt(envVar, 10);
  return Number.isFinite(n) && n > 0 ? n : defaultValue;
}

export default {
  getEnvName,
  readNonZeroNaturalNumber,
};
